import Button from "@/components/button"
import { ChevronRight } from "@/components/icons/outline"
import CreatePost from "@/components/partials/create-post"
import Spinner from "@/components/spinner"
import { useAuth } from "@/contexts/auth-context"
import Main from "@/layouts/main"
import useCategoryRepos from "@/repositories/category"
import usePostRepos from "@/repositories/post"
import moment from "moment"
import { Link, useNavigate } from "react-router-dom"

export default function Category() {
    // Contexts
    const { user } = useAuth()

    // Hooks
    const navigate = useNavigate()

    const { data: categoryData, isLoading: isLoadingCategoryData, mutate: mutateCategoryData } = useCategoryRepos({})

    return (
        <Main title="Category" headerTitle="Category">
            <div className="divide-y">
                {isLoadingCategoryData && (
                    <div className="flex items-center justify-center p-6">
                        <Spinner />
                    </div>
                )}

                {/* Posts */}
                {!isLoadingCategoryData && categoryData?.map((row) => (
                    <Link to={`/category/${row.slug}`} key={row.id} className="flex flex-col w-full p-6 space-y-6">
                        <div className="flex justify-between w-full">
                            <div className="flex space-x-4">
                                <div className="flex flex-col items-start justify-between">
                                    {/* Name */}
                                    <p className="inline-flex items-center text-sm font-semibold">{row.name} <span className="ml-1 text-xs text-neutral-500">{row.user?.role?.name}</span></p>
                                    {/* Timestamp */}
                                    <p className="text-xs text-neutral-500">{row._count.post} Post{row._count.post > 1 ? 's' : ''}</p>
                                </div>
                            </div>
                            <div>
                                <ChevronRight className="w-8 h-8" />
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </Main>
    )
}